import { SvgIcon, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Zoom from '@material-ui/core/Zoom';
import React from 'react';
import { Link } from 'react-router-dom';
import { Checker } from '../../../../../SharedLibs/Checker.js';
import { lang, translate } from '../../../../../SharedLibs/Langs.js';
import { ConfigStore } from '../../../flux/stores/ConfigStore';
import { AccountServices } from '../../../services/AccountServices';
import { MessageServices } from '../../../services/MessageServices';
import PasswordField from '../Lib/PasswordField.jsx';
import { IconManager } from '../ReactToolBox/IconManager.jsx';
import GenericFormular from './GenericFormular.jsx';

var md = require("markdown").markdown;



// ---- For debugging ------
// import { debugInit } from '../../../../../SharedLibs/Debug.js';
// var debug = debugInit("Account");


const styles = (theme) => ({
	layout: {
		width: 'auto',
		display: 'block', // Fix IE11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400,
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	paper: {
		marginTop: theme.spacing.unit * 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	},
	avatar: {
		backgroundColor: 'transparent',
		width: 'unset',
		height: 'unset',
		borderRadius: "unset"
	},
	form: {
		width: '100%', // Fix IE11 issue.
		marginTop: theme.spacing.unit,
	},
	email: {
		width: '100%', // Fix IE11 issue.
		marginTop: theme.spacing.unit * 3,
		marginBottom: theme.spacing.unit * 3,

	},
	submit: {
		marginTop: theme.spacing.unit * 3,
	},
	link: {
		textDecoration: 'none',
		color: 'inherit'
	},
	content: {
		padding: '25px 0px'
	},
	img64 : {
		width: '64px',
		height: '64px',
		'& span' : {
			'& svg' : {
				width: '64px',
				height: '64px',
			}
		},
	}
});

class SignUp extends GenericFormular {
	constructor(props) {
		super(props);

		this.title = translate("CREATE AN ACCOUNT");

		//this.state.contentClasName = "signUpFormContent";
		this.state.key = "signUpKey";
		this.state.contentClassName = "signUpForm";


		this.state._pathname = props._pathname ? props._pathname : "";
		this.state._path = props._path ? props._path : "";
		this.state.confirmString = props.confirmString;
		this.state.seePassword = false;
		this.state.seePasswordConfirm = false;
		this.state.stepIndex = 0;
		this.state.data.agree_gcu = false;
		this.state.data.email = props.email ? props.email : props.login ? props.login : "";
		this.state.data.password = "";
		this.state.open = false;

		this.checkForValidity = this.checkForValidity.bind(this);
		this.signup = this.signup.bind(this);
		this.toggleSeePassword = this.toggleSeePassword.bind(this);
		this.toggleSeePasswordConfirm = this.toggleSeePasswordConfirm.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.update = this.update.bind(this);
		this.renderGcuDialog = this.renderGcuDialog.bind(this);


		this.state.onSubmit = this.signup;
		this.state.stepIndex = props.signup ? parseInt(props.signup) : 0;
		this.state.submitDisabled = true;
		this.state.showGcu = false;

		this.handleChange = this.handleChange.bind(this);
		this.state.defaultGcuContent = "<div class='center'><h1>" + translate("Loading") + "...</h1></div>";
		this.state.gcuContent = this.state.defaultGcuContent;

		this.actions = [
			<Button
				color="secondary"
				variant="contained"
				id="refuse_gcu"
				key="refuse_gcu"
				onClick={this.handleClose}
			>
				{translate("Close")}
			</Button>,
			<Button
				id="agree_gcu"
				key="agree_gcu"
				name="agree_gcu"
				variant="contained"
				color="primary"

				onClick={() => { this.handleSwitchChange("agree_gcu")(true) }}
			>
				{translate("Accept")}
			</Button>,
		];


	}

	componentWillReceiveProps(props) {
		this.update(props.global.urlParams);
	}

	handleSwitchChange = (name) => (value) => {
		let initialData = Object.assign({}, this.state.data);
		initialData[name] = value;
		this.setState({ data: initialData }, () => { this.checkForValidity(initialData) });
	};


	update(props) {
		let stepIndex = props.signup ? parseInt(props.signup) : 0;
		let initialData = Object.assign({}, this.state.data);
		if (!this.state.data.email) initialData.email = props.email ? props.email : "";
		this.setState({ "stepIndex": stepIndex, "data": initialData });
		//this.onChange();
	}


	toggleSeePassword() {
		return this.setState({ "seePassword": !this.state.seePassword });
	}

	toggleSeePasswordConfirm() {
		return this.setState({ "seePasswordConfirm": !this.state.seePasswordConfirm });
	}

	checkForValidity(d) {
		this.state.errorTextEmail = undefined;
		this.state.errorTextPassword = undefined;
		this.state.submitDisabled = false;

		if (this.state.stepIndex == 0) {
			if (new Checker("email+").check(d.email) != true) {
				this.state.errorTextEmail = translate("Must be a valid email");
				this.state.submitDisabled = true;
			}
		}

		if (!d.email) this.state.submitDisabled = true;
		if (!d.agree_gcu) this.state.submitDisabled = true;
		if (!d.password) this.state.submitDisabled = true;

		// ------- check for empty email -----
		return this.setState({
			data: d,
			errorTextEmail: d.email ? this.state.errorTextEmail : "",
			submitDisabled: this.state.submitDisabled,
			open: false,
		});
	}


	renderNewButtons() {
		return ([]);
	}

	handleClose() {
		this.setState({ "open": false });
	}

	handleOpen() {
		if (this.state.gcuContent === this.defaultGcuContent) {
			return this.setState({ "open": true });
		}

		return this.setState({ "open": true, "gcuContent": ConfigStore.getCGU(lang) });
	}


	renderContent() {
		return (
			<React.Fragment>


				{
					this.state.stepIndex === 0 ? this.renderSignUpFormContent() :
						this.state.stepIndex === 1 ? this.renderConfirmationMailSentContent() :
							this.state.stepIndex === 2 ? this.renderMailConfirmedContent() : 
								this.state.stepIndex === 4 ? this.renderActivedAccountContent() : this.renderStepErrorContent()
				}
				{
					this.state.stepIndex === 0 ? this.renderConfirmSignupButton() :
						this.state.stepIndex === 1 ? this.renderGoToLoginLink() :
							this.state.stepIndex === 2 ? this.renderGoToLoginButton() : 
								this.state.stepIndex === 4 ? this.renderGoToLoginButton() : this.renderStepErrorButton()
				}

			</React.Fragment>
		);

	}

	renderConfirmSignupButton() {
		return (
			<Button
				id="signUpSubmit"
				type="submit"
				fullWidth
				variant="contained"
				color="primary"
				className={this.props.classes.submit}
				disabled={this.state.submitDisabled}
				onClick={this.state.onSubmit}
			>
				{translate("Confirm")}
			</Button>
		)
	}

	renderGoToLoginLink() {

		return (
			<Typography color="primary">
				<Link className={this.props.classes.link} to={this.state._path + "?login=" + this.state.data.email}>{translate("Back to login")}</Link>
			</Typography>

		);

	}

	renderGoToLoginButton() {
		return (
			<Button
				id="signUpGoLogin"
				key="submit"
				color="primary"
				variant="contained"
				onClick={() => { this.props.global.linkTo(this.state._path + "?login=" + this.state.data.email) }}
			>
				{IconManager.getIconByName("user")}
				{translate("Login")}
			</Button>
		);
	}

	renderStepErrorButton() {
		return (
			<Button
				id="signUpCancel"
				className="cancel"
				variant="text"
				onClick={() => { this.props.global.linkTo(this.state._path + "?signup=0&email=" + this.state.data.email) }}
			>
				{translate("Prev")}
			</Button>
		);
	}

	handleChange(event) {
		const { name, value } = event.currentTarget;
		this.setState({ [name]: value });
	}

	renderSignUpFormContent() {

		return (
			<React.Fragment>
				{this.renderAppLogo()}
				<Typography key="title" variant="h6">{this.title}</Typography>
				<form key="form" className={this.props.classes.form}>
					<TextField
						className={this.props.classes.email}
						id={"email"}
						key={"email"}
						//ref="email" 
						name={"email"}
						variant='outlined'
						multiline={false}
						required={true}
						//className={this.props.classes.password}
						//disabled={false}
						//type={this.state.view ? undefined : 'password'}
						label={translate("Email")}
						helperText={this.state.errorTextEmail}
						value={this.state.data.email}
						readOnly={this.state.data.email === this.props.email}
						onChange={this.handleTextChange('email')}
					/>

					<PasswordField
						key="password"
						_id="passphrase"
						confirm={true}
						canSee={true}
						withScore={true}
						label={translate("Choose a password")}
						onChange={(password) => {
							this.state.data.password = password;
							return this.checkForValidity(this.state.data);
						}}
					/>

					<FormControlLabel
						control={
							<Checkbox
								name="gcu"
								id="signUpGcu"
								color="primary"
								onChange={() => {
									if (this.state.data.agree_gcu) {
										this.handleSwitchChange("agree_gcu")(false);
									} else {
										this.handleOpen();
									}
								}}
								checked={this.state.data.agree_gcu}
							/>
						}
						label={translate("I read and I accept terms and conditions")}
						key="cgu"
					/>



				</form>
				{this.renderGcuDialog()}
			</React.Fragment>

		);

	}

	renderGcuDialog() {
		let tree = md.parse(this.state.gcuContent);
		let html = md.renderJsonML(md.toHTMLTree(tree));

		return (
			<Dialog
				open={this.state.open ? true : false}
				onClose={this.handleClose}
				scroll="paper"
				key="cgu_dialog"
				TransitionComponent={Zoom}
			>
				<DialogContent>
					<DialogContentText>
						<div id="cguContentDiv" dangerouslySetInnerHTML={{ __html: html }}></div>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					{this.actions}
				</DialogActions>

			</Dialog>


		);
	}

	renderConfirmationMailSentContent() {
		return (
			<React.Fragment >

				<SvgIcon
					id="mailSentForSignup"
					color="primary"
					className={this.props.classes.img64}
				>
					{IconManager.getIconByName("email")}
				</SvgIcon>


				<Typography gutterBottom>{translate("A email has been sent")} : </Typography>
				<Typography gutterBottom>{this.props.email}</Typography>
				<Typography className={this.props.classes.content} gutterBottom>{translate("Please check your email and click on the verification link.")}</Typography>

			</React.Fragment>
		);
	}

	renderMailConfirmedContent() {
		return (
			<React.Fragment>
				<SvgIcon
					id="mailConfirmedForSignup"
					color="primary"
					className={this.props.classes.img64}
				>
					{IconManager.getIconByName("verified", "green")}
				</SvgIcon>
				<Typography className={this.props.classes.content} gutterBottom>
					{translate("Your email is validated")}
				</Typography>
			</React.Fragment>
		);
	}
	
	renderActivedAccountContent() {
		return (
			<React.Fragment>
				<SvgIcon
					id="accountActivatedOnSignup"
					color="primary"
					className={this.props.classes.img64}
				>
					{IconManager.getIconByName("verified", "green")}
				</SvgIcon>
				<Typography className={this.props.classes.content} gutterBottom>
					{translate("Your account is created and ready to use")}
				</Typography>
			</React.Fragment>
		);
	}

	renderStepErrorContent() {
		return (

			<React.Fragment>
				<SvgIcon
					color="error"
					className={this.props.classes.img64}
				>
					{IconManager.getIconByName("alert")}
				</SvgIcon>
				<Typography className={this.props.classes.content} gutterBottom>
					{translate("Your email cannot be validate !")}
				</Typography>
			</React.Fragment>

		);
	}


	signup() {
		let d = {};
		d.email = this.state.data.email;
		d.password = this.state.data.password;
		d._path = this.state._path;
		if (this.state.confirmString) d.confirmString = this.state.confirmString;
		AccountServices.signUp(d)
			.then((isActive) => {
				if (isActive === "ACTIVE")
					return this.props.global.linkTo(this.state._path + "?signup=4&email=" + this.state.data.email);
				return this.props.global.linkTo(this.state._path + "?signup=1&email=" + this.state.data.email);
			})
			.catch((err) => {
				this.disableSubmitButton(false);
				return MessageServices.setInStore({ "error": err });
			})
	}
}

export default withStyles(styles)(SignUp)